import { z } from "zod";

export const CompanySectorSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    name: z.string(),
    ssqId: z
        .number()
        .nullish()
        .transform((value) => value ?? undefined),
});

// Define the main company schema with simple recursive structure
export const CompanySchema = z.object({
    "@id": z.string(),
    "@type": z.string().optional(),
    id: z.number(),
    name: z.string(),
    isProvider: z.boolean().optional(),
    canView: z.boolean().optional(),
    canModify: z.boolean().optional(),
    canDelete: z.boolean().optional(),
    // Simplified organizationType - just accept any format from API
    organizationType: z.any().optional().nullable(),
    organizationSector: CompanySectorSchema.optional(),
    // Use z.any() for recursive relations to avoid Zod complexity
    parents: z.array(z.any()).optional(),
    children: z.array(z.any()).optional(),
    // Keep other fields simple
    users: z.array(z.any()).optional(),
});

export type Company = z.infer<typeof CompanySchema>;
export type CompanySector = z.infer<typeof CompanySectorSchema>;
